<template>
  <div class="fetching__overlay">
    <Spinner :theme="primary" :style="{ fontSize: '2rem' }" />
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";

export default {
  name: "FetchingOverlay",
  components: {
    Spinner
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  }
};
</script>

<style lang="scss" scoped>
.fetching__overlay {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 1100;
  top: 0;
  min-height: 100vh;
  width: 100%;
  left: 0;
}
</style>
